import React from "react";
import "./LoginPage.scss";
import { Link } from "react-router-dom";
import { FaUserTie } from "@react-icons/all-files/fa/FaUserTie";
import { FaUserAlt } from "@react-icons/all-files/fa/FaUserAlt";

const LoginPage = () => {
  return (
    <div className="main-login-area flex-col w-full justify-center items-center animate__animated animate__fadeIn">
      <div className="w-full justify-center flex flex-col gap-2 items-center ">
        <a href="http://www.hasvetratem.com">
          <img
            className="w-96 p-2 md:p-0"
            src="/assets/images/logo.png"
            alt="Logo"
          />
        </a>
        <span className="text-4xl font-bold text-blue-500 mt-6 drop-shadow-md   duration-300">
          Hoş geldiniz.
        </span>
      </div>
      <div className="duration-300  text-xl xl:w-2/3 font-semibold p-4 flex flex-col items-center">
        <div className=" xl:w-1/2 justify-center flex flex-col mt-6">
          <div className="grid 2xl:grid-cols-2 gap-4 items-center justify-center">
            <Link to="/clinic-login">
              <div className="col-span-1 py-4 px-2 justify-center text-lg text-center text-white border-red-500 bg-red-500 border duration-100 hover:opacity-80 hover:border-red-400 rounded-md drop-shadow-md items-center flex gap-2">
                <FaUserTie className="text-base" />
                Veteriner Hekim Girişi
              </div>
            </Link>

            <Link to="/user-login">
              <div className="col-span-1 text-lg py-4 px-2 justify-center border text-center  border-yellow-500 bg-yellow-500 text-white hover:opacity-80 duration-200 hover:border-yellow-400 rounded-md drop-shadow-md items-center flex gap-2">
                <FaUserAlt className="text-base" />
                Hasta Sahibi Girişi
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
